module.exports = __webpack_public_path__ + "static/media/clients.df7b27ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/clients.png
// module id = 1104
// module chunks = 0